var map = {
	"./en.js": 64,
	"./es.js": 65,
	"./fr.js": 66,
	"./pt.js": 67,
	"./ru.js": 68,
	"./tr.js": 69
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 188;



//////////////////
// WEBPACK FOOTER
// ./src/i18n \.(js)$
// module id = 188
// module chunks = 2